// Loads the Google AdSense loader script once. Renders nothing visible.
// Mount once near the root; safe to mount unconditionally — it self-noops
// when ads should not be shown or the script is already present.
import { useEffect } from "react";
import {
  ADSENSE_CLIENT_ID,
  useShouldShowAds,
} from "@/lib/should-show-ads";

const SCRIPT_ID = "adsbygoogle-loader";

export const AdSenseScript = () => {
  const enabled = useShouldShowAds();

  useEffect(() => {
    if (!enabled || !ADSENSE_CLIENT_ID) return;
    if (document.getElementById(SCRIPT_ID)) return;

    const s = document.createElement("script");
    s.id = SCRIPT_ID;
    s.async = true;
    s.crossOrigin = "anonymous";
    s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT_ID}`;
    document.head.appendChild(s);
  }, [enabled]);

  return null;
};
